<style scoped>

</style>
<template>
  <step lastRoute="litigationStep1" nextRoute="litigationStep3"></step>
</template>

<script>
  import step2 from '../../../../components/project/step2'
  export default {
    name: "step2",//利冲报告
    components:{
      step:step2,
    },
  }
</script>
